import { useQuery } from '@tanstack/react-query';
import { DEFAULT_LIMIT } from '../../../Services/constants';
import useLocationQuery from '../../../../hooks/useQuery';
import { getQuestionnaires } from '../../../../apis/questionnaires/requests';

export const useQuestionnaires = () => {
  const { query } = useLocationQuery();

  const pageToFetch = query.page || 0;
  const limit = query.limit || DEFAULT_LIMIT;

  const { data: questionnairesResponse, isFetched: isLoaded } = useQuery({
    queryKey: ['questionnaires', pageToFetch, limit],
    queryFn: () => getQuestionnaires(pageToFetch, limit),
    meta: { errorMessage: 'Failed to load questionnaires list' }
  });

  const total = questionnairesResponse?.pagination?.total || 0;

  return {
    questionnaires: questionnairesResponse?.data || [],
    isLoaded,
    total
  };
};
